module.exports = __webpack_public_path__ + "static/media/logo.f689d700.svg";